import styled from 'styled-components';
import { body2, colors, spacing } from 'ui/theme';

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.threeQuarter} 0;
`;

export const Name = styled.span`
  ${body2}
`;

export const Detail = styled.span`
  ${body2}
  color: ${colors.textSecondary};
`;

export const RightContent = styled.div`
  align-items: center;
  display: flex;
  gap: 0.375rem;
`;

export const TooltipUl = styled.ul`
  margin-bottom: 0;
  padding-left: ${spacing.base};
  & > * {
    list-style-type: disc;
  }
`;

export const Details = styled.div`
  display: flex;
`;

export const ID = styled.div`
  margin-right: ${spacing.half};

  &:only-child {
    margin-right: 0;
  }
`;
